import { Link } from "react-router-dom";
import { categoryColorMap } from "@/mocks/categories";

interface ArticleCardProps {
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  author: string;
  publishDate: string;
  readTime: string;
  imageUrl: string;
  categoryName: string;
}

export default function ArticleCard({
  slug,
  title,
  category,
  excerpt,
  author,
  publishDate,
  readTime,
  imageUrl,
  categoryName,
}: ArticleCardProps) {
  const colorRole = categoryColorMap[category] || "primary";

  return (
    <article className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-background-300/60 transition-all duration-300 flex flex-col">
      <Link to={`/article/${slug}`} className="block overflow-hidden cursor-pointer">
        <div className="w-full aspect-[5/3] overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            title={`${title} - 第一次指南`}
            className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-center gap-3 mb-3">
          <span
            className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap bg-${colorRole}-100 text-${colorRole}-700`}
          >
            {categoryName}
          </span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">{readTime}</span>
        </div>
        <Link to={`/article/${slug}`} className="cursor-pointer">
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 mb-4 line-clamp-2 leading-relaxed flex-1">
          {excerpt}
        </p>
        <div className="flex items-center justify-between pt-3 border-t border-background-200/70 mt-auto">
          <span className="text-xs text-foreground-500">{author}</span>
          <span className="text-xs text-foreground-400">{publishDate}</span>
        </div>
      </div>
    </article>
  );
}